import React from "react";
import PropTypes from "prop-types";
import ChevronDown from "../svg/ICON_chevronDown_Dark.svg";
import "../css/Body.css";

/**
 * Body Component
 */
class Body extends React.Component {
  static displayName = "Body";
  static propTypes = {
    className: PropTypes.string,
    screen: PropTypes.string.isRequired,
    children: PropTypes.node,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "Body";
  }

  /**
   * @override
   */
  render() {
    return (
      <div className={`${this.className} ${this.props.className || ""}`}>
        {this.props.screen === "mobile" && (
          <div className={`${this.className}__chevron`}>
            <img src={ChevronDown} alt="Chevron" />
          </div>
        )}
        <div className={`${this.className}__wrapper`}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Body;



// WEBPACK FOOTER //
// ./src/components/Body.js